import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import * as moment from "moment";
import { Observable } from 'rxjs';
import { mergeMap } from "rxjs/operators";
import { ConfigService } from "../../../../config/config.service";
import { Client } from "../../../shared/client/client";

@Injectable({
  providedIn: 'root'
})
export class DeliveryDetailsService {

  /**
   *
   * @param {HttpClient} http
   * @param {ConfigService} configService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
  }

  /**
   *
   * @param {Client} client
   * @param {string} date
   * @param {string} code
   * @returns {Observable<Object>}
   */
  getDetails(client: Client, date: Date, code: string): Observable<Array<Object>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Object>>(
          config.apiPoint + config.getClientDelivery.replace("{client}", client.id).replace("{date}", moment(date).format("Y-MM-DD")).replace("{codeArticle}", code)
        );
      }));
  }
}
